import { ReactComponent as Spinner } from "assets/images/iconsV2/spinner.svg";
import "./LoadingSpinner.scss";

interface LoadingSpinnerProps {
  /**
   * The size of the spinner.
   *
   * 16px | 24px | 32px or any custom size
   *
   * @default "16px"
   */
  size?: string;
}

export default function LoadingSpinner({ size = "16px" }: LoadingSpinnerProps) {
  return <Spinner width={size} height={size} className="v2-loading-spinner" />;
}

LoadingSpinner.defaultProps = {
  size: "16px",
};
